export default __webpack_public_path__ + "static/media/BureauLogo.b6417f30.jpg";